import type { PrematchFilterFromBack } from './types';

import { DATA_GA_EVENT, SEARCH_PARAM_KEY, timeFilterTabItemAll } from './constants';

export const PREMATCH_FILTERS_FROM_BACK: PrematchFilterFromBack[] = [
  {
    value: 60,
    output: 1,
    template: 1,
  },
  {
    value: 180,
    output: 3,
    template: 1,
  },
  {
    value: 360,
    output: 6,
    template: 1,
  },
  {
    value: 720,
    output: 12,
    template: 1,
  },
  {
    value: 1440,
    output: 24,
    template: 1,
  },
  {
    value: 2880,
    output: 2,
    template: 2,
  },
];

export const timeFilterTabItems = {
  defaultActiveId: 'all',
  items: [
    timeFilterTabItemAll,
    {
      id: '1h',
      label: '1ч',
      to: `?${SEARCH_PARAM_KEY}=1h`,
      dataGaValues: {
        ['data-ga-event']: `${DATA_GA_EVENT}-1h`,
      },
    },
    {
      id: '3h',
      label: '3ч',
      to: `?${SEARCH_PARAM_KEY}=3h`,
      dataGaValues: {
        ['data-ga-event']: `${DATA_GA_EVENT}-3h`,
      },
    },
    {
      id: '6h',
      label: '6ч',
      to: `?${SEARCH_PARAM_KEY}=6h`,
      dataGaValues: {
        ['data-ga-event']: `${DATA_GA_EVENT}-6h`,
      },
    },
    {
      id: '12h',
      label: '12ч',
      to: `?${SEARCH_PARAM_KEY}=12h`,
      dataGaValues: {
        ['data-ga-event']: `${DATA_GA_EVENT}-12h`,
      },
    },
    {
      id: '24h',
      label: '24ч',
      to: `?${SEARCH_PARAM_KEY}=24h`,
      dataGaValues: {
        ['data-ga-event']: `${DATA_GA_EVENT}-24h`,
      },
    },
    {
      id: '2d',
      label: '2 д',
      to: `?${SEARCH_PARAM_KEY}=2d`,
      dataGaValues: {
        ['data-ga-event']: `${DATA_GA_EVENT}-2d`,
      },
    },
  ],
};
